import React from 'react';
import { Button } from 'react-bootstrap';

interface ProjectEmptyStateProps {
  title: string;
  description: string;
  actionLabel?: string;
  onAction?: () => void;
}

const ProjectEmptyState: React.FC<ProjectEmptyStateProps> = ({
  title,
  description,
  actionLabel,
  onAction,
}) => (
  <div className="project-empty-state text-center py-4">
    <div className="project-empty-state__title fw-semibold">{title}</div>
    <div className="project-empty-state__description text-muted small mt-1">{description}</div>
    {actionLabel && onAction && (
      <div className="mt-3">
        <Button size="sm" variant="outline-primary" onClick={onAction}>
          {actionLabel}
        </Button>
      </div>
    )}
  </div>
);

export default ProjectEmptyState;
